import api from './api';

const TeacherService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/users/teachers/', { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  createTeacher: async (data) => {
    try {
      const response = await api.post('/users/create-teacher/', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default TeacherService;
